'use strict';

import React, { Component } from 'react';
import styled from 'styled-components';

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { css } from 'emotion';
import CTAButtonContainer from './CTAButtonContainer';

var jsonData = require('./landingpagedata.json');

const sliderSettings = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 1.1,
  slidesToScroll: 1,
  accessibility:false,
  focusOnSelect:true
};

export default class CallToActionContainer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Container>
        <SectionTitle>Ertu með verkefni í huga?</SectionTitle>
        <RowSection>
          <RowItem >
            <Slider {...sliderSettings}>
                {this._renderData()}
            </Slider>
        </RowItem>
        <RowItem style={{flex:1}}>
          <CTAButtonContainer
          url={"/contact/"}
          text={"Ræðum þín verkefni!"}
          buttonStyle={css`${defaultButtonStyle}`}
          containerStyle={css`${buttonContainerStyles}`}

          />
        </RowItem>
      </RowSection>
    </Container>
    );
  }

  _renderData(){
    let result = [];
    let i = 0;
    jsonData.CTATexts.forEach( (eachItem) => {
      i++;
      let key = "CTAText"+ i;
      result.push(
        <div key={key}>
          <QuoteCard style={cardContainerStyle}
           title={eachItem.title}
           excerpt={eachItem.excerpt}
           link={eachItem.link}
           />
        </div>
      );
    });
  return (result);
  }
}

class QuoteCard extends Component {
 constructor(props) {
   super(props);
 }

 render() {
   const {title, excerpt, link} = this.props;
   return (
     <Card>
       <CardTitle>{title}</CardTitle>
       <QuoteTextColumn>
         {this.addLineFeed(excerpt)}
         <div style={{padding:"1rem 0 1rem"}}>
         <a href={link} className={css`${moreInfoButtonStyles}`}>Nánari upplýsingar</a>
         </div>
       </QuoteTextColumn>
     </Card>
   );
 }

 addLineFeed(text,renderImageLabel){
   if(renderImageLabel){
     return text.split('\n').map((item, i) => {
         return <ImageLabelLineProd key={i}>{item}</ImageLabelLineProd>;
     });
   }
   else{
     return text.split('\n').map((item, i) => {
         return <p className={css`${pStyles}`} key={i}>{item}</p>;
     });
   }
 }
}

/*
*  QuoteContainer styles
*/
const Container = styled.section`
  overflow:hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding-bottom:1.8rem;
  background: #FFF;
`;

const SectionTitle = styled.section`
  display: flex;
  flex: 1;
  //height: 60px;
  margin: 20px 0px;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  margin-left: 1.8rem;
  //color: #FFF;
  color: #5E7CA0;
  font-size: 1.3em;
  line-height: 1.2em;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
`;

const RowSection = styled.section`
  position: relative;
  display: flex; //content;
  flex:1;
  flex-direction: row;
  flex-wrap: wrap;
  width:100%;
  justify-content:center;
`;

const RowItem = styled.section`
  width: 100%;
`
//Inline styling https://codeburst.io/4-four-ways-to-style-react-components-ac6f323da822
const cardContainerStyle =  {
  padding: "20px 0 0",
};

/*
*  Card styles
*/
//styled components
const Card = styled.section`
  padding: 0 1.8rem 0;
  //width:100%;
`;

//Inline styling https://codeburst.io/4-four-ways-to-style-react-components-ac6f323da822
const CardTitle = styled.section`
  text-align:left;
  color: #FFFFFF;
  color: #5E7CA0;
  margin-top: 0;
  font-size: 1.5em;
  line-height: 1.5em;
  font-weight:500;
`;

const QuoteTextColumn = styled.section`
  flex: 1 1 70%;  //Causing quoteCard not to wrap
  height: auto;
  //color: #FFFFFF;
  color: #5E7CA0;

  text-align: left;
  font-size:  1.25em;
  line-height: 1.45em;
  `

const moreInfoButtonStyles = css`
  text-decoration: none;  
  border-color:#E88D67;
  color: #E88D67;
  border-style: solid;
  padding: 7px 7px;
  border-radius: 10px;
  border-width: 2px;
  font-size: small;
  transition: 0.4s;
  &:hover {
    color:#fff;
    background-color: #E88D67;
  }
  `
  
  const buttonContainerStyles = css`
    flex: 1;
    text-align:center;
    margin: 3rem 1.8rem 0;
  `
  const defaultButtonStyle = css`
    text-decoration: none;
    color: #FFF;
    background-color:  #E88D67; 
    border-width: 4px;
    border-color: #E88D67;
    border-style:solid;
    border-width: 2px;
    padding: 15px 25px;
    border-radius: 10px;
    text-transform: uppercase;
    font-size: larger;
    font-weight:500;
    transition: 0.4s;
    &:hover {
      color:#E88D67;
      background-color: #fff;
    }
`
const pStyles = css`
    margin-bottom: 0.5rem;
  `
